module.exports = __webpack_public_path__ + "static/milestonecards-d0748fccb9ccbb10b893b89d6a9f7618.png";